import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { saveCardDetails } from 'services/actions/accountAction';
import { message } from 'components/shared/AntComponent';
import { Button } from 'components/shared/ButtonComponent';
import { Radio } from 'components/shared/FormComponent';
import { InfoCircleOutlined, CheckCircleFilled } from 'components/shared/AntIcons';

const PaymentInformationScreen: React.FC = () => {
    const [payVia, setPayVia] = useState('credit');
    const dispatch = useDispatch();
    const { billingTypeInfo, loading5, success13, error13, cardInfo, loading13 } = useSelector((state: any) => state.account);
    const [showSuccessmsg4, setShowSuccessmsg4] = useState(false);
    const successmsg4 = showSuccessmsg4 ? success13 : false;
    const [showErrormsg4, setShowErrormsg4] = useState(false);
    const errormsg4 = showErrormsg4 ? error13 : null;
    const firstPaidFlag = sessionStorage.getItem('firstPaidFlag') === "true" ? true : sessionStorage.getItem('firstPaidFlag') === "false" ? false : null

    const handlePayChange = (e: any) => {
        setPayVia(e.target.value);
    }

    const proceedToPay = () => {
        const protocol = window.location.protocol;
        const port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
        const success = `${protocol}//${window.location.hostname}${port ? ':' + port : ''}/success-autopay`;
        const error = `${protocol}//${window.location.hostname}${port ? ':' + port : ''}/error-autopay`;

        const inputJson = {
            accountid: sessionStorage.getItem('accountID') || 578,
            payment_method_type: payVia,
            paymentemail: sessionStorage.getItem('email') || "9fjqxw3xvi@wnbaldwy.com",
            success_url: success,
            cancel_url: error,
        };
        dispatch(saveCardDetails(inputJson) as any);
        setShowErrormsg4(true);
        setShowSuccessmsg4(true);
    }

    useEffect(() => {
        if (successmsg4 && cardInfo?.url) {
            window.location.href = cardInfo?.url;
            setShowSuccessmsg4(false);
        }
        if (errormsg4) {
            message.success("Card details can't be updated");
            setShowSuccessmsg4(false);
            setShowErrormsg4(false);
        }
    }, [successmsg4, errormsg4]);
    
    return (
        <div className="p-4 bg-light autopay-enable-screen h-100">
            <div className='w-25 mx-auto my-3'>
                <h5 className='text-center'>Setup Autopay</h5>
                <p className='fs-13 text-center'>Enable seamless automatic payments</p>
                <div className='bg-white p-3 rounded shadow-sm mb-3'>
                    <h6>Account Details</h6>
                    <div className="mt-3 bg-light p-2">
                        <small className='text-gray fs-13'>Account Name</small>
                        <br />
                        {/* <strong className="fs-13">Albert John</strong> */}
                        <strong className='fs-13'>{sessionStorage.getItem('firstname') || "Albert" + " " + sessionStorage.getItem("lastname") || " John"}</strong>
                    </div>
                    <div className="mt-2 bg-light p-2">
                        <small className='text-gray fs-13'>Account Email</small>
                        <br />
                        <strong className="fs-13">{sessionStorage.getItem('email') || "albertjohnclinic@gmail.com"}</strong>
                    </div>
                </div>
                {firstPaidFlag ? "" :
                    <div className='bg-lightSuccess rounded p-3 mb-3 d-flex'>
                        <div className='col-auto'>
                            <CheckCircleFilled className='text-success fs-24' />
                        </div>
                        <div className='col ps-2'>
                            <h6>Special Offer</h6>
                            <h6>Your first order is completely free!</h6>
                            <div className="mt-3">
                                <ul>
                                    <li>Payment will be deducted from your second order onwards</li>
                                    <li>No hidden charges or subscription fees</li>
                                </ul>
                            </div>
                        </div>
                    </div>}
                <div className='bg-lightBlue rounded p-3 d-flex'>
                    <div className='col-auto'>
                        <InfoCircleOutlined className='text-blue' />
                    </div>
                    <div className="col ps-2">
                        <h6>Sample Payment Required</h6>
                        <p className=''>
                            To enable autopay, a sample payment will be charged to
                            verify your payment method. This amount will be credited back to your account
                            within 2-3 business days.
                        </p>
                    </div>
                </div>
                <div className='bg-white shadow-sm rounded p-3 mt-3'>
                    <h6>Payment Information</h6>
                    <div className='mt-3'>
                        <Radio.Group className="fw-normal mt-2" onChange={handlePayChange} value={payVia} >
                            <Radio value="card" className="fs-15">
                                Credit Card
                            </Radio>
                            <Radio value="us_bank_account" className="fs-15">
                                ACH
                            </Radio>
                        </Radio.Group>
                    </div>
                </div>
                <div className='mt-3'>
                    <Button type="primary" className='w-100' loading={loading13} onClick={proceedToPay}>Proceed to pay</Button>
                </div>
            </div>

        </div>
    )
}

export default PaymentInformationScreen;